import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SegmentedControlRadioComponent } from '@ibe.components/common/segmented-control-radio/segmented-control-radio.component';
// import { TAPSegmentedControlRadioComponent } from '@ibe.components/common/segmented-control-radio/segmented-control-radio.tap.component';

import { INDRASegmentedControlRadioComponent } from '@ibe.components/common/segmented-control-radio/segmented-control-radio.indra.component';
import { DirectivesModule } from 'src/app/directives/directives.module';
@NgModule({
  imports: [CommonModule, DirectivesModule],
  declarations: [SegmentedControlRadioComponent, INDRASegmentedControlRadioComponent],
	exports: [INDRASegmentedControlRadioComponent]
})
export class SegmentedControlRadioModule { }
